import { mapGetters } from 'vuex';

export default {
    name: 'dspReview',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dsp', ['dsp']),
    },
    props: {
        reviewUrl: {
            type: String,
            default: () => {
                return '';
            },
        },
    },
    mounted() {
        this.initial();
    },
    methods: {
        showMoreReviews(event) {
            event.target.closest('.desc').classList.toggle('open');
        },
        checkOverflow() {
            this.$refs.dspReviews.querySelectorAll('.desc').forEach(function (item) {
                var hasOverflow = item.scrollHeight > item.clientHeight + 6;
                if (!hasOverflow) {
                    $(item).addClass('open');
                } else {
                    $(item).removeClass('open');
                }
            });
        },
        initial() {
            this.checkOverflow();
        },
    },
};
